import { useEffect, useRef, useState } from "react";

const CHANNELS = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-link", label: "复制链接" },
  { icon: "ri-more-fill", label: "更多" },
];

export default function ShareButton() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 border border-background-50/40 bg-background-50/10 text-background-50 text-sm font-medium px-5 py-2.5 rounded-md hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-share-forward-line" />
        分享
      </button>
      {open && (
        <div className="absolute left-0 bottom-full mb-2 z-20 w-52 rounded-lg border border-background-200 bg-background-50 p-3 shadow-sm">
          <p className="text-xs text-foreground-500 mb-2 px-1">分享到</p>
          <div className="grid grid-cols-4 gap-2">
            {CHANNELS.map((ch) => (
              <button
                key={ch.label}
                type="button"
                aria-label={ch.label}
                className="flex flex-col items-center gap-1 py-1.5 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={ch.icon} />
                </span>
                <span className="text-[10px] text-foreground-600">{ch.label}</span>
              </button>
            ))}
          </div>
          <p className="text-[10px] text-foreground-400 mt-2 px-1 leading-relaxed">
            演示功能，暂未接入真实分享渠道。
          </p>
        </div>
      )}
    </div>
  );
}